// extracted by mini-css-extract-plugin
export default {"container":"FeeCounter_container__MuBrq","counter_box":"FeeCounter_counter_box__JXJJp","counter":"FeeCounter_counter__3csn0","colored":"FeeCounter_colored__V167H"};